<div #actionBar class="catalog__actionBar vc-d-md-none">
  <button
    *ngIf="alertsEnabled"
    appOpenAlertPopin
    [configCatalog]="configCatalog"
    class="catalog__actionBar__button catalog__actionBar__button--alert"
  >
    <vc-sprite-icons name="bell-full" class="catalog__actionBar__button__icon"></vc-sprite-icons>
    <span i18n="@@CATALOG.ALERT_BUTTON">Alert</span>
  </button>
  <button *ngIf="hasSort" class="catalog__actionBar__button" (click)="emitAction('sort')" i18n="@@CATALOG.SORT_BUTTON">
    Sort
  </button>
  <button class="catalog__actionBar__button" (click)="emitAction('filters')" i18n="@@CATALOG.FILTER_BUTTON">
    Filter by
  </button>
</div>
